<mat-card class="dmeslog-card" >
  <mat-card-header>
    <div mat-card-avatar class="dmesg-header-image"><mat-icon aria-hidden="false" aria-label="home icon">account_circle</mat-icon></div>
    <mat-card-title> DMESG LOGGING   </mat-card-title>
  </mat-card-header>
  <mat-card-content>


<table>
<tr *ngFor="let log of dmesglog">
  <td>{{log.TIME}}</td>
  <td>{{log.LEVEL}}</td>
  <td><small>{{log.MESSAGE}}</small></td>
</tr>
</table>


  </mat-card-content>
</mat-card>
